

export const CategoryInfos = [

  {
    title: "men's clothing",
    name: "men's clothing",
    imgLink: "https://fakestoreapi.com/img/71YXzeOuslL._AC_UY879_.jpg"
  },
  {
    title: "Women's clothing",
    name: "women's clothing",
    imgLink: "https://fakestoreapi.com/img/71z3kpMAYsL._AC_UY879_.jpg"
  },
  {
    title: "jewelery",
    name: "jewelery",
    imgLink: "https://fakestoreapi.com/img/61sbMiUnoGL._AC_UL640_QL65_ML3_.jpg"
  },
  {
    title: "electronics",
    name: "electronics",
    imgLink: "https://fakestoreapi.com/img/81Zt42ioCgL._AC_SX679_.jpg"
  }
];